<template>
	<div class="statistics-management">
		<el-card class="general-card">
			<template #header>
				<div class="card-header">
					<div class="header-extra">
						<div class="page-title">统计分析</div>
						<div class="select-group" v-if="activeTab === 'opportunityAnalysis'">
							<el-select v-model="selectedOpportunity" style="width: 260px" placeholder="选择商机">
								<el-option v-for="item in opportunityList" :key="item.id" :label="item.name"
									:value="item.id">
									<span style="float: left">{{ item.name }}</span>
									<span style="float: right; color: #8492a6; font-size: 13px">
										{{ formatMoney(item.expectedAmount) }}
									</span>
								</el-option>
							</el-select>
						</div>
						<el-divider direction="vertical"></el-divider>
						<div class="button-group select-group">
							<el-button type="primary" @click="prevMonth"><el-icon style="color: #FFF;">
									<ArrowLeft />
								</el-icon>上一月</el-button>
							<el-date-picker v-model="selectedMonth" type="month" placeholder="选择月份"
								style="width: 150px;" :clearable="false" @change="handleMonthChange" format="YYYY-MM" />
							<el-button type="primary" @click="nextMonth" :disabled="isNextMonthDisabled">下一月<el-icon
									style="color: #FFF;">
									<ArrowRight />
								</el-icon></el-button>
						</div>
						<!-- <el-select v-if="activeTab === 'work'" v-model="selectedUser"
							style="width: 200px; margin-left: 16px" placeholder="选择人员" @change="handleUserChange">
							<el-option v-for="user in userList" :key="user.id" :value="user.id"
								:label="user.username" />
						</el-select> -->
						<!-- <el-divider direction="vertical"></el-divider>
						<div class="select-group" v-if="activeTab === 'opportunityAnalysis'">
							<el-select v-model="selectedOpportunity" style="width: 300px" placeholder="选择商机"
								@change="handleOpportunityChange">
								<el-option v-for="item in opportunityList" :key="item.id" :label="item.name"
									:value="item.id">
									<span style="float: left">{{ item.name }}</span>
									<span style="float: right; color: #8492a6; font-size: 13px">
										{{ formatMoney(item.expectedAmount) }}
									</span>
								</el-option>
							</el-select>
						</div> -->
					</div>
				</div>
			</template>

			<el-tabs v-model="activeTab" class="custom-tabs" type="border-card">
				<el-tab-pane label="人员工作统计" name="work">
					<el-row :gutter="20">
						<el-col :sm="24" :md="12" :lg="6" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>客户跟进</span>
										<el-tooltip content="统计周期内的客户跟进次数" placement="top">
											<el-icon>
												<QuestionFilled />
											</el-icon>
										</el-tooltip>
									</div>
								</template>
								<div class="statistic-card">
									<span class="number">{{ statistics.customerFollowUps }}</span>
									<span class="label">次</span>
								</div>
							</el-card>
						</el-col>
						<el-col :sm="24" :md="12" :lg="6" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>商机转化</span>
										<el-tooltip content="统计周期内的商机转化数量" placement="top">
											<el-icon>
												<QuestionFilled />
											</el-icon>
										</el-tooltip>
									</div>
								</template>
								<div class="statistic-card">
									<span class="number">{{ statistics.opportunityConversions }}</span>
									<span class="label">个</span>
								</div>
							</el-card>
						</el-col>
						<el-col :sm="24" :md="12" :lg="6" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>合同签订</span>
										<el-tooltip content="统计周期内的合同签订数量" placement="top">
											<el-icon>
												<QuestionFilled />
											</el-icon>
										</el-tooltip>
									</div>
								</template>
								<div class="statistic-card">
									<span class="number">{{ statistics.contractSignings }}</span>
									<span class="label">份</span>
								</div>
							</el-card>
						</el-col>
						<el-col :sm="24" :md="12" :lg="6" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>回款金额</span>
										<el-tooltip content="统计周期内的回款总金额" placement="top">
											<el-icon>
												<QuestionFilled />
											</el-icon>
										</el-tooltip>
									</div>
								</template>
								<div class="statistic-card">
									<span class="number">{{ formatMoney(statistics.paymentAmount || 0) }}</span>
									<span class="label">元</span>
								</div>
							</el-card>
						</el-col>
					</el-row>
					<!-- <el-divider /> -->
					<!-- 每个饼状图单独一行，居中显示 -->
					<el-row :gutter="20">
						<el-col :lg="24" :xl="12" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>客户跟进</span>
									</div>
								</template>
								<pie-chart :title="'客户跟进'" :data="pieFollowUpData" height="350px"
									@sector-click="id => handlePieChartClick('customer', id)" />
							</el-card>
						</el-col>
						<el-col :lg="24" :xl="12" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>商机转化</span>
									</div>
								</template>
								<pie-chart :title="'商机转化'" :data="pieOpportunityData" height="350px"
									@sector-click="id => handlePieChartClick('opportunity', id)" />
							</el-card>
						</el-col>
						<el-col :lg="24" :xl="12" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>合同签订</span>
									</div>
								</template>
								<pie-chart :title="'合同签订'" :data="pieContractData" height="350px"
									@sector-click="id => handlePieChartClick('contract', id)" />
							</el-card>
						</el-col>
						<el-col :lg="24" :xl="12" class="pb-10">
							<el-card shadow="hover">
								<template #header>
									<div class="card-header">
										<span>回款金额</span>
									</div>
								</template>
								<pie-chart :title="'回款金额'" :data="piePaymentData" height="350px"
									@sector-click="id => handlePieChartClick('payment', id)" />
							</el-card>
						</el-col>
					</el-row>

					<el-divider />

					<!-- 新增：客户类型分布饼状图 -->
					<!-- <el-card shadow="hover" class="stat-card" style="margin-bottom: 24px;">
            <template #header>
              <div class="card-header">
                <span>客户类型分布</span>
                <el-tooltip content="各类型客户占比" placement="top">
                  <el-icon><QuestionFilled /></el-icon>
                </el-tooltip>
              </div>
            </template>
            <PieChart :title="'客户类型分布'" :data="customerTypeData" height="400px" />
          </el-card> -->

					<el-tabs v-model="workTab" class="detail-tabs" type="border-card">
						<el-tab-pane label="客户跟进记录" name="customer">
							<el-table :data="customerData" :loading="loading" border style="width: 100%" height="500px">
								<el-table-column prop="customerName" label="客户名称" align="center" />
								<el-table-column prop="createTime" label="跟进时间" align="center">
									<template #default="scope">
										{{ formatDateTime(scope.row.createTime) }}
									</template>
								</el-table-column>
								<el-table-column prop="notes" label="跟进内容" align="center" />
								<el-table-column prop="type" label="跟进方式" align="center" />
								<el-table-column prop="username" label="跟进人" align="center" />
							</el-table>
							<div class="pagination-container">
								<el-pagination v-model:current-page="customerPagination.current"
									v-model:page-size="customerPagination.pageSize" :total="customerPagination.total"
									:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
									@size-change="(val) => handleSizeChange(val, 'customer')"
									@current-change="(val) => handleCurrentChange(val, 'customer')" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="商机转化记录" name="opportunity">
							<el-table :data="opportunityData" :loading="loading" border style="width: 100%"
								height="500px">
								<el-table-column prop="name" label="商机名称" align="center" />
								<el-table-column prop="customerName" label="客户名称" align="center" />
								<el-table-column prop="createTime" label="转化时间" align="center">
									<template #default="scope">
										{{ formatDateTime(scope.row.createTime) }}
									</template>
								</el-table-column>
								<el-table-column prop="expectedAmount" label="金额" align="center">
									<template #default="scope">
										{{ formatMoney(scope.row.expectedAmount) }}
									</template>
								</el-table-column>
								<el-table-column prop="username" label="转化人" align="center" />
							</el-table>
							<div class="pagination-container">
								<el-pagination v-model:current-page="opportunityPagination.current"
									v-model:page-size="opportunityPagination.pageSize"
									:total="opportunityPagination.total" :page-sizes="[10, 20, 50, 100]"
									layout="total, sizes, prev, pager, next, jumper"
									@size-change="(val) => handleSizeChange(val, 'opportunity')"
									@current-change="(val) => handleCurrentChange(val, 'opportunity')" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="合同签订记录" name="contract">
							<el-table :data="contractData" :loading="loading" border style="width: 100%" height="500px">
								<el-table-column prop="contractNumber" label="合同编号" align="center" />
								<el-table-column prop="customerName" label="客户名称" align="center" />
								<el-table-column prop="signedDate" label="签订时间" align="center">
									<template #default="scope">
										{{ formatDate(scope.row.signedDate) }}
									</template>
								</el-table-column>
								<el-table-column prop="totalAmount" label="合同金额" align="center">
									<template #default="scope">
										{{ formatMoney(scope.row.totalAmount) }}
									</template>
								</el-table-column>
								<el-table-column prop="username" label="签订人" align="center" />
								<el-table-column label="合同附件" width="120" align="center">
									<template #default="{ row }">
										<el-link v-if="row.contractFile" type="primary"
											@click="handleContractFilePreview(row.url)">
											查看附件
										</el-link>
										<span v-else class="text-muted">无附件</span>
									</template>
								</el-table-column>
							</el-table>
							<div class="pagination-container">
								<el-pagination v-model:current-page="contractPagination.current"
									v-model:page-size="contractPagination.pageSize" :total="contractPagination.total"
									:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
									@size-change="(val) => handleSizeChange(val, 'contract')"
									@current-change="(val) => handleCurrentChange(val, 'contract')" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="回款记录" name="payment">
							<el-table :data="paymentData" :loading="loading" border style="width: 100%" height="500px">
								<el-table-column prop="number" label="回款编号" align="center" />
								<el-table-column prop="customerName" label="客户名称" align="center" />
								<el-table-column prop="createTime" label="回款时间" align="center">
									<template #default="scope">
										{{ formatDate(scope.row.createTime) }}
									</template>
								</el-table-column>
								<el-table-column prop="money" label="回款金额" align="center">
									<template #default="scope">
										{{ formatMoney(scope.row.money) }}
									</template>
								</el-table-column>
								<el-table-column prop="returnType" label="回款方式" align="center" />
								<el-table-column prop="username" label="回款人" align="center" />
								<el-table-column label="回款单" width="120" align="center">
									<template #default="{ row }">
										<el-link v-if="row.receiptFile" type="primary"
											@click="handleReceiptFilePreview(row.url)">
											查看回款单
										</el-link>
										<span v-else class="text-muted">无回款单</span>
									</template>
								</el-table-column>
							</el-table>
							<div class="pagination-container">
								<el-pagination v-model:current-page="paymentPagination.current"
									v-model:page-size="paymentPagination.pageSize" :total="paymentPagination.total"
									:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
									@size-change="(val) => handleSizeChange(val, 'payment')"
									@current-change="(val) => handleCurrentChange(val, 'payment')" />
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-tab-pane>

				<el-tab-pane label="商机统计分析" name="opportunityAnalysis">
					<div v-if="selectedOpportunity">
						<!-- 商机基本信息只读区 -->
						<el-card shadow="hover">
							<el-descriptions :column="2" border>
								<el-descriptions-item label="商机名称">{{opportunityDetail.name }}</el-descriptions-item>
								<el-descriptions-item
									label="客户名称">{{ opportunityDetail.customerName }}</el-descriptions-item>
								<el-descriptions-item
									label="预计金额">{{ formatMoney(opportunityDetail.expectedAmount) }}</el-descriptions-item>
								<el-descriptions-item label="商机状态">
									<el-tag :type="getStatusType && getStatusType(opportunityDetail.stage)">
										{{ getStatusText && getStatusText(opportunityDetail.stage) }}
									</el-tag>
								</el-descriptions-item>
								<el-descriptions-item
									label="预计成交日期">{{ formatDate(opportunityDetail.expectedCloseDate) }}</el-descriptions-item>
								<el-descriptions-item
									label="创建时间">{{ formatDateTime(opportunityDetail.createTime) }}</el-descriptions-item>
								<el-descriptions-item label="商机描述" :span="2">
									<span
										style="white-space: pre-wrap">{{ opportunityDetail.description || '无' }}</span>
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<!-- 统计卡片 -->
						<h3 class="section-title">统计概览</h3>
						<el-row :gutter="20">
							<el-col :sm="24" :md="12" :lg="6" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>跟进次数</span>
											<el-tooltip content="该商机的跟进记录次数" placement="top">
												<el-icon>
													<QuestionFilled />
												</el-icon>
											</el-tooltip>
										</div>
									</template>
									<div class="statistic-card">
										<span class="number">{{ opportunityStats.followUpCount }}</span>
										<span class="label">次</span>
									</div>
								</el-card>
							</el-col>
							<el-col :sm="24" :md="12" :lg="6" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>参与人数</span>
											<el-tooltip content="参与该商机跟进的人员数量" placement="top">
												<el-icon>
													<QuestionFilled />
												</el-icon>
											</el-tooltip>
										</div>
									</template>
									<div class="statistic-card">
										<span class="number">{{ opportunityStats.participantCount }}</span>
										<span class="label">人</span>
									</div>
								</el-card>
							</el-col>
							<el-col :sm="24" :md="12" :lg="6" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>商机金额</span>
											<el-tooltip content="该商机的预期金额" placement="top">
												<el-icon>
													<QuestionFilled />
												</el-icon>
											</el-tooltip>
										</div>
									</template>
									<div class="statistic-card">
										<span class="number">{{ formatMoney(opportunityStats.expectedAmount) }}</span>
										<span class="label">元</span>
									</div>
								</el-card>
							</el-col>
							<el-col :sm="24" :md="12" :lg="6" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>跟进天数</span>
											<el-tooltip content="从商机创建到现在的天数" placement="top">
												<el-icon>
													<QuestionFilled />
												</el-icon>
											</el-tooltip>
										</div>
									</template>
									<div class="statistic-card">
										<span class="number">{{ opportunityStats.followUpDays }}</span>
										<span class="label">天</span>
									</div>
								</el-card>
							</el-col>
						</el-row>

						<!-- 商机跟进方式分布饼状图 -->
						<el-row :gutter="20">
							<el-col :md="24" :lg="12" :xl="8" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>跟进次数</span>
										</div>
									</template>
									<PieChart :title="'跟进次数'" :data="opportunityPieDataGen" height="350px"
										@sector-click="handlePieChartClick" />
								</el-card>
							</el-col>
							<el-col :md="24" :lg="12" :xl="8" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>合同签订</span>
										</div>
									</template>
									<PieChart :title="'合同签订'" :data="opportunityPieDataHe" height="350px"
										@sector-click="handlePieChartClick" />
								</el-card>
							</el-col>
							<el-col :md="24" :lg="12" :xl="8" class="pb-10">
								<el-card shadow="hover">
									<template #header>
										<div class="card-header">
											<span>回款金额</span>
										</div>
									</template>
									<PieChart :title="'回款金额'" :data="opportunityPieDataHui" height="350px"
										@sector-click="handlePieChartClick" />
								</el-card>
							</el-col>
						</el-row>

						<!-- 跟进记录表格 -->
						<h3 class="section-title">跟进记录</h3>
						<el-table :data="followUpRecords" :loading="loading" border style="width: 100%"
							:header-cell-style="tableHeaderStyle" :cell-style="tableCellStyle">
							<el-table-column prop="createTime" label="跟进时间" align="center" width="180">
								<template #default="scope">
									{{ formatDateTime(scope.row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="username" label="跟进人" align="center" width="120" />
							<el-table-column prop="type" label="跟进方式" align="center" width="120" />
							<el-table-column prop="notes" label="跟进内容" align="center" />
							<el-table-column prop="username" label="跟进人" align="center" />
						</el-table>
						<div class="pagination-container">
							<el-pagination v-model:current-page="followUpPagination.current"
								v-model:page-size="followUpPagination.pageSize" :total="followUpPagination.total"
								:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
								@size-change="(val) => handleSizeChange(val, 'followUp')"
								@current-change="(val) => handleCurrentChange(val, 'followUp')" />
						</div>

						<!-- 参与人员分析表格 -->
						<h3 class="section-title">参与人员分析</h3>
						<el-table :data="participantAnalysis" :loading="loading" border style="width: 100%"
							:header-cell-style="tableHeaderStyle" :cell-style="tableCellStyle">
							<el-table-column prop="username" label="人员" align="center" />
							<el-table-column prop="followUpCount" label="跟进次数" align="center" />
							<el-table-column prop="lastFollowUpTime" label="最后跟进时间" align="center">
								<template #default="scope">
									{{ formatDateTime(scope.row.lastFollowUpTime) }}
								</template>
							</el-table-column>
						</el-table>

						<!-- 报价明细 -->
						<h3 class="section-title">报价明细</h3>
						<el-table :data="quotationList" border style="width: 100%">
							<el-table-column type="index" label="序号" width="60" />
							<el-table-column prop="name" label="报价编号" min-width="150"></el-table-column>
							<el-table-column prop="customerName" label="客户名称" min-width="240"></el-table-column>
							<el-table-column prop="offerPrice" label="报价金额" min-width="100">
								<template #default="{ row }">
									{{ formatAmount(row.offerPrice) }}
								</template>
							</el-table-column>
							<el-table-column prop="offerTime" label="报价时间" width="120">
								<template #default="{ row }">
									{{ formatDate(row.offerTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="status" label="报价状态" width="120">
								<template #default="{ row }">
									<el-tag :type="getStatusTypeOffer && getStatusTypeOffer(row.status)">
										{{ getStatusTextOffer && getStatusTextOffer(row.status) }}
									</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="创建时间" width="180">
								<template #default="{ row }">
									{{ formatDateTime(row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="username" label="报价人" align="center" />
							<el-table-column label="操作" width="100">
								<template #default="{ row }">
									<el-button type="primary" size="small"
										@click="showQuotationDetail(row)">详情</el-button>
								</template>
							</el-table-column>
						</el-table>

						<!-- 合同明细 -->
						<h3 class="section-title">合同明细</h3>
						<el-table :data="contractList" border style="width: 100%">
							<el-table-column type="index" label="序号" width="60" />
							<el-table-column prop="contractNumber" label="合同编号"></el-table-column>
							<el-table-column prop="contractName" label="合同名称" />
							<el-table-column prop="totalAmount" label="合同金额">
								<template #default="{ row }">
									¥{{ formatAmount(row.totalAmount) }}
								</template>
							</el-table-column>
							<el-table-column prop="signedDate" label="签订日期">
								<template #default="{ row }">
									{{ formatDate(row.signedDate) }}
								</template>
							</el-table-column>
							<el-table-column prop="username" label="签订人" align="center" />
							<el-table-column label="合同附件" width="120" align="center">
								<template #default="{ row }">
									<el-link v-if="row.contractFile" type="primary"
										@click="handleContractFilePreview(row.url)">
										查看附件
									</el-link>
									<span v-else class="text-muted">无附件</span>
								</template>
							</el-table-column>
						</el-table>

						<!-- 回款明细 -->
						<h3 class="section-title">回款明细</h3>
						<el-table :data="paymentList" border style="width: 100%">
							<el-table-column type="index" label="序号" width="60" />
							<el-table-column prop="number" label="回款编号"></el-table-column>
							<el-table-column prop="money" label="回款金额">
								<template #default="{ row }">
									¥{{ formatAmount(row.money) }}
								</template>
							</el-table-column>
							<el-table-column prop="returnTime" label="回款时间">
								<template #default="{ row }">
									{{ formatDateTime(row.returnTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="returnType" label="回款方式" />
							<el-table-column prop="username" label="回款人" align="center" />
							<el-table-column label="回款单" width="120" align="center">
								<template #default="{ row }">
									<el-link v-if="row.receiptFile" type="primary"
										@click="handleReceiptFilePreview(row.url)">
										查看回款单
									</el-link>
									<span v-else class="text-muted">无回款单</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-empty v-else description="请选择商机" />
				</el-tab-pane>
			</el-tabs>
		</el-card>

		<el-dialog class="mydialog" v-model="workDialogVisible" width="60vw" title="明细表单" :close-on-click-modal="false">
			<template v-if="workDialogType === 'customer'">
				<h3 class="section-title">客户跟进记录</h3>
				<el-table :data="dialogCustomerData" :loading="loading" border style="width: 100%" height="40vh">
					<el-table-column prop="customerName" label="客户名称" />
					<el-table-column prop="createTime" label="跟进时间" align="center" width="200px">
						<template #default="scope">{{ formatDateTime(scope.row.createTime) }}</template>
					</el-table-column>
					<el-table-column prop="notes" label="跟进内容" />
					<el-table-column prop="type" label="跟进方式" align="center" width="120px" />
					<el-table-column prop="username" label="跟进人" align="center" width="120px" />
				</el-table>
				<div class="pagination-container">
					<el-pagination v-model:current-page="dialogCustomerPagination.current"
						v-model:page-size="dialogCustomerPagination.pageSize" :total="dialogCustomerPagination.total"
						:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
						@size-change="val => handleDialogSizeChange(val, 'customer')"
						@current-change="val => handleDialogCurrentChange(val, 'customer')" />
				</div>
			</template>
			<template v-else-if="workDialogType === 'opportunity'">
				<h3 class="section-title">商机转化记录</h3>
				<el-table :data="dialogOpportunityData" :loading="loading" border style="width: 100%" height="40vh">
					<el-table-column prop="name" label="商机名称" />
					<el-table-column prop="customerName" label="客户名称" />
					<el-table-column prop="createTime" label="转化时间" align="center" width="200px">
						<template #default="scope">{{ formatDateTime(scope.row.createTime) }}</template>
					</el-table-column>
					<el-table-column prop="expectedAmount" label="金额" align="center" width="150px">
						<template #default="scope">{{ formatMoney(scope.row.expectedAmount) }}</template>
					</el-table-column>
					<el-table-column prop="username" label="转化人" align="center" width="120px" />
				</el-table>
				<div class="pagination-container">
					<el-pagination v-model:current-page="dialogOpportunityPagination.current"
						v-model:page-size="dialogOpportunityPagination.pageSize"
						:total="dialogOpportunityPagination.total" :page-sizes="[10, 20, 50, 100]"
						layout="total, sizes, prev, pager, next, jumper"
						@size-change="val => handleDialogSizeChange(val, 'opportunity')"
						@current-change="val => handleDialogCurrentChange(val, 'opportunity')" />
				</div>
			</template>
			<template v-else-if="workDialogType === 'contract'">
				<h3 class="section-title">合同签订记录</h3>
				<el-table :data="dialogContractData" :loading="loading" border style="width: 100%" height="40vh">
					<el-table-column prop="contractNumber" label="合同编号" />
					<el-table-column prop="customerName" label="客户名称" />
					<el-table-column prop="signedDate" label="签订时间" align="center" width="200px">
						<template #default="scope">{{ formatDate(scope.row.signedDate) }}</template>
					</el-table-column>
					<el-table-column prop="totalAmount" label="合同金额" align="center" width="150px">
						<template #default="scope">{{ formatMoney(scope.row.totalAmount) }}</template>
					</el-table-column>
					<el-table-column prop="username" label="签订人" align="center" width="120px" />
					<el-table-column label="合同附件" width="120" align="center">
						<template #default="{ row }">
							<el-link v-if="row.contractFile" type="primary" @click="handleContractFilePreview(row.url)">
								查看附件
							</el-link>
							<span v-else class="text-muted">无附件</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination-container">
					<el-pagination v-model:current-page="dialogContractPagination.current"
						v-model:page-size="dialogContractPagination.pageSize" :total="dialogContractPagination.total"
						:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
						@size-change="val => handleDialogSizeChange(val, 'contract')"
						@current-change="val => handleDialogCurrentChange(val, 'contract')" />
				</div>
			</template>
			<template v-else-if="workDialogType === 'payment'">
				<h3 class="section-title">回款记录</h3>
				<el-table :data="dialogPaymentData" :loading="loading" border style="width: 100%" height="40vh">
					<el-table-column prop="number" label="回款编号" />
					<el-table-column prop="customerName" label="客户名称" />
					<el-table-column prop="createTime" label="回款时间" align="center" width="200px">
						<template #default="scope">{{ formatDate(scope.row.createTime) }}</template>
					</el-table-column>
					<el-table-column prop="money" label="回款金额" align="center" width="150px">
						<template #default="scope">{{ formatMoney(scope.row.money) }}</template>
					</el-table-column>
					<el-table-column prop="returnType" label="回款方式" align="center" width="150px" />
					<el-table-column prop="username" label="回款人" align="center" width="120px" />
					<el-table-column label="回款单" width="120" align="center">
						<template #default="{ row }">
							<el-link v-if="row.receiptFile" type="primary" @click="handleReceiptFilePreview(row.url)">
								查看回款单
							</el-link>
							<span v-else class="text-muted">无回款单</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination-container">
					<el-pagination v-model:current-page="dialogPaymentPagination.current"
						v-model:page-size="dialogPaymentPagination.pageSize" :total="dialogPaymentPagination.total"
						:page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
						@size-change="val => handleDialogSizeChange(val, 'payment')"
						@current-change="val => handleDialogCurrentChange(val, 'payment')" />
				</div>
			</template>
		</el-dialog>

		<el-dialog v-model="quotationDetailDialogVisible" title="报价详情" width="1200px" :close-on-click-modal="false">
			<el-descriptions :column="1" border>
				<el-descriptions-item label="报价编号">{{ currentQuotationDetail.name }}</el-descriptions-item>
				<el-descriptions-item label="客户名称">{{ currentQuotationDetail.customerName }}</el-descriptions-item>
				<el-descriptions-item
					label="报价金额">{{ formatAmount(currentQuotationDetail.offerPrice) }}</el-descriptions-item>
				<el-descriptions-item
					label="报价时间">{{ formatDate(currentQuotationDetail.offerTime) }}</el-descriptions-item>
				<el-descriptions-item label="报价状态">
					<el-tag :type="getStatusTypeOffer && getStatusTypeOffer(currentQuotationDetail.status)">
						{{ getStatusTextOffer && getStatusTextOffer(currentQuotationDetail.status) }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item
					label="创建时间">{{ formatDateTime(currentQuotationDetail.createTime) }}</el-descriptions-item>
				<el-descriptions-item label="报价人">{{ currentQuotationDetail.username }}</el-descriptions-item>
			</el-descriptions>
			<!-- 审批列表 -->
			<el-table :data="approvalList" border style="margin-top: 20px">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="examineName" label="审批标题"></el-table-column>
				<el-table-column prop="username" label="申请人"></el-table-column>
				<el-table-column prop="createTime" label="申请时间">
					<template #default="scope">
						{{ formatDateTime(scope.row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="审批状态">
					<template #default="scope">
						<el-tag :type="getStatusTypeApp(scope.row.status)">
							{{ getStatusTextApp(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="currentApprover" label="当前审批人"></el-table-column>
				<el-table-column label="操作" width="100" fixed="right">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>

						<!-- <el-button
              v-if="scope.row.status === 'pending' && isApplicant(scope.row)"
              size="mini"
              type="danger"
              @click="handleWithdraw(scope.row)">撤回</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<template #footer>
				<el-button @click="quotationDetailDialogVisible = false">关闭</el-button>
			</template>
		</el-dialog>

		<el-dialog v-model="approvalFlowDialogVisible" title="审批流程" width="700px" :close-on-click-modal="false">
			<div class="contacts-section">
				<el-timeline>
					<el-timeline-item v-for="(activity, index) in currentApprovalFlow" :key="index"
						:type="getTimelineItemType(activity.status)">
						<div class="timeline-item-content">
							<h4>第{{ index + 1 }}步</h4>
							<p><strong>审批人：</strong>{{ activity.username }}</p>
							<p><strong>审批状态：</strong>
								<el-tag :type="getStatusType1(activity.status)" size="small">
									{{ getStatusText1(activity.status) }}
								</el-tag>
							</p>
							<p v-if="activity.examineOpinion">
								<strong>审批意见：</strong>{{ activity.examineOpinion }}
							</p>
							<p><strong>审批时间：</strong>{{ formatDateTime(activity.updateTime) }}</p>
						</div>
					</el-timeline-item>
				</el-timeline>
			</div>
			<template #footer>
				<el-button @click="approvalFlowDialogVisible = false">关闭</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		ElMessage
	} from 'element-plus'
	import {
		QuestionFilled
	} from '@element-plus/icons-vue'
	import dayjs from 'dayjs'
	import {
		getUserList,
		getStaUser,
		getWorkStatistics,
		getCustomerFollowUps,
		getOpportunityConversions,
		getContractSignings,
		getPaymentRecords,
		getOpportunityAnalysis,
		getOpportunityList,
		getOpportunityFollowUps,
		getBusinessTeam,
		getBusinessDetail,
		getBusinessRec,
		getBusinessContract,
		getBusinessOffer,
		getExamineList,
		getExamineFlowDetail
	} from '@/api/statistics'
	import PieChart from '@/components/PieChart.vue'
	// import { approveApproval } from '@/api/approval'

	export default {
		name: 'StatisticsManagement',
		components: {
			QuestionFilled,
			PieChart
		},
		data() {
			// const now = new Date()
			// const year = now.getFullYear()
			// const month = now.getMonth() == 0 ? now.getMonth() + 1 : now.getMonth()
			const lastDayDate = dayjs().subtract(1, 'month').format('YYYY-MM');
			const firstDay = dayjs(lastDayDate).startOf('month').format('YYYY-MM-DD');
			const lastDay = dayjs(lastDayDate).endOf('month').format('YYYY-MM-DD');
			// const lastDay = `${year}-${String(month).padStart(2, '0')}-${String(lastDayDate.getDate()).padStart(2, '0')}`
			return {
				quotationList: [],
				opportunityDetail: {},
				selectedMonth: lastDayDate,
				pickerOptions: {
					disabledDate(time) {
						// 禁用未来月份
						return time.getTime() > Date.now();
					},
				},
				monthRange: [firstDay, lastDay],
				dateRange: [dayjs().subtract(30, 'days'), dayjs()],
				dateShortcuts: [{
						text: '最近一周',
						value: () => {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							return [start, end]
						}
					},
					{
						text: '最近一个月',
						value: () => {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
							return [start, end]
						}
					},
					{
						text: '最近三个月',
						value: () => {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							return [start, end]
						}
					}
				],
				selectedUser: null,
				userList: [],
				loading: false,
				workTab: 'customer',
				opportunityAnalysisTab: 'overview',
				selectedOpportunity: null,
				opportunityList: [],
				statistics: {
					customerFollowUps: 0,
					opportunityConversions: 0,
					contractSignings: 0,
					paymentAmount: 0
				},
				opportunityStats: {
					followUpCount: 0,
					participantCount: 0,
					expectedAmount: 0,
					followUpDays: 0
				},
				opportunitySourceData: [],
				opportunityStageData: [],
				customerPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				opportunityPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				contractPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				paymentPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				customerData: [],
				opportunityData: [],
				contractData: [],
				paymentData: [],
				followUpRecords: [],
				participantAnalysis: [],
				followUpPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				customerTypeData: [{
						value: 40,
						name: '企业客户'
					},
					{
						value: 30,
						name: '个人客户'
					},
					{
						value: 20,
						name: 'VIP客户'
					},
					{
						value: 10,
						name: '其他'
					}
				],
				pieFollowUpData: [

				],
				pieOpportunityData: [

				],
				pieContractData: [

				],
				piePaymentData: [

				],
				opportunityPieData: [{
						value: 40,
						name: '电话'
					},
					{
						value: 35,
						name: '拜访'
					},
					{
						value: 25,
						name: '微信'
					}
				],
				opportunityPieDataHe: [],
				opportunityPieDataGen: [],
				opportunityPieDataHui: [],
				activeTab: 'work',
				workDialogVisible: false,
				workDialogType: '', // 'customer' | 'opportunity' | 'contract' | 'payment'
				selectedPieId: null,
				dialogCustomerData: [],
				dialogOpportunityData: [],
				dialogContractData: [],
				dialogPaymentData: [],
				dialogCustomerPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				dialogOpportunityPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				dialogContractPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				dialogPaymentPagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				quotationDetailDialogVisible: false,
				currentQuotationDetail: {},
				approvalFlowDialogVisible: false,
				currentApprovalFlow: [],
			}
		},
		created() {
			this.loadData()
			//this.handleMonthChange(this.selectedMonth)
		},
		mounted() {
			// this.getStatic();
			this.fetchUserList()
			this.fetchOpportunityList()
			// this.fetchStatistics()
			// this.fetchTableData()
			this.$nextTick(() => {})
			window.addEventListener('resize', this.handleResize)
		},
		computed: {
			// 判断是否禁用"下一月"按钮
			isNextMonthDisabled() {
				if (!this.selectedMonth) return true;
				const current = new Date();
				const selected = new Date(this.selectedMonth);
				// 比较年份和月份（注意月份是 0-11）
				return (
					selected.getFullYear() > current.getFullYear() ||
					(selected.getFullYear() === current.getFullYear() &&
						selected.getMonth() >= current.getMonth())
				);
			},
		},
		methods: {
			getTimelineItemType(status) {
				const typeMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return typeMap[status] || 'info'
			},
			getStatusType1(status) {
				const statusMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success',
					4: 'info'
				}
				return statusMap[status] || 'info'
			},
			getStatusText1(status) {
				const statusMap = {
					'-1': '未进行',
					0: '审批中',
					2: '已拒绝',
					1: '已通过',
					4: '已撤销'
				}
				return statusMap[status] || status
			},
			prevMonth() {
				const date = new Date(this.selectedMonth);
				date.setMonth(date.getMonth() - 1);
				this.selectedMonth = date;
			},
			// 下一月
			nextMonth() {
				const date = new Date(this.selectedMonth);
				date.setMonth(date.getMonth() + 1);
				this.selectedMonth = date;
			},
			getStatusTypeApp(status) {
				const statusMap = {
					1: 'warning',
					3: 'success',
					2: 'danger',
					4: 'info'
					// withdrawn: 'info'
				}
				return statusMap[status] || 'info'
			},
			getStatusTextApp(status) {
				const statusMap = {
					1: '审批中',
					3: '已通过',
					2: '已拒绝',
					4: '已撤销'
					// withdrawn: '已撤回'
				}
				return statusMap[status] || status
			},
			getStatusType(status) {
				const statusMap = {
					0: 'info',
					1: 'warning',
					2: 'primary',
					3: 'success',
					4: 'success',
					5: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					0: '初步接触',
					1: '需求确认',
					2: '方案报价',
					3: '商务谈判',
					4: '赢单',
					5: '输单'
				}
				return statusMap[status] || status
			},
			async getStatic() {
				const params = {
					userId: this.selectedUser,
					startDate: dayjs(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
					endDate: dayjs(this.selectedMonth).endOf('month').format('YYYY-MM-DD'),
				}
				const res1 = await getStaUser(params)
				this.pieFollowUpData = res1.data.pieFollowUpData;
				this.pieOpportunityData = res1.data.pieOpportunityData;
				this.pieContractData = res1.data.pieContractData;
				this.piePaymentData = res1.data.piePaymentData;
			},
			formatDateTime(date) {
				return date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : '-'
			},
			formatDate(date) {
				return date ? dayjs(date).format('YYYY-MM-DD') : '-'
			},
			formatMoney(amount) {
				return amount ? `¥${Number(amount).toLocaleString()}` : '-'
			},
			formatAmount(amount) {
				return amount ? amount.toLocaleString('zh-CN', {
					minimumFractionDigits: 2
				}) : '0.00'
			},
			async fetchUserList() {
				try {
					const {
						data
					} = await getUserList()
					this.userList = data
				} catch (error) {
					ElMessage.error('获取用户列表失败')
				}
			},
			async fetchStatistics() {
				this.loading = true
				try {
					const params = {
						userId: this.selectedUser,
						startDate: dayjs(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
						endDate: dayjs(this.selectedMonth).endOf('month').format('YYYY-MM-DD'),
					}
					const res = await getWorkStatistics(params)
					this.statistics = res.data
					this.getStatic();
				} catch (error) {
					ElMessage.error('获取统计数据失败')
				} finally {
					this.loading = false
				}
			},
			async fetchTableData(type = 'customer', id = null) {
				this.loading = true
				try {
					const params = {
						userId: id || this.selectedUser,
						startDate: dayjs(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
						endDate: dayjs(this.selectedMonth).endOf('month').format('YYYY-MM-DD'),
						page: this[`${type}Pagination`].current,
						pageSize: this[`${type}Pagination`].pageSize
					}

					let res
					switch (type) {
						case 'customer':
							res = await getCustomerFollowUps(params)
							this.customerData = res.data.records || []
							this.customerPagination.total = res.data.total || 0
							break
						case 'opportunity':
							res = await getOpportunityConversions(params)
							this.opportunityData = res.data.records || []
							this.opportunityPagination.total = res.data.total || 0
							break
						case 'contract':
							res = await getContractSignings(params)
							this.contractData = res.data.records || []
							this.contractPagination.total = res.data.total || 0
							break
						case 'payment':
							res = await getPaymentRecords(params)
							this.paymentData = res.data.records || []
							this.paymentPagination.total = res.data.total || 0
							break
					}
				} catch (error) {
					ElMessage.error('获取表格数据失败')
				} finally {
					this.loading = false
				}
			},
			async fetchOpportunityAnalysis() {
				if (!this.selectedUser) {
					ElMessage.warning('请先选择人员')
					return
				}
				this.loading = true
				try {
					const params = {
						userId: this.selectedUser,
						startDate: dayjs(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
						endDate: dayjs(this.selectedMonth).endOf('month').format('YYYY-MM-DD'),
					}
					const res = await getOpportunityAnalysis(params)
					this.opportunityStats = res.data.stats || {}
					this.opportunitySourceData = res.data.sourceAnalysis || []
					this.opportunityStageData = res.data.stageAnalysis || []
				} catch (error) {
					console.error('获取商机分析数据失败:', error)
					ElMessage.error('获取商机分析数据失败')
				} finally {
					this.loading = false
				}
			},
			getStatusTypeOffer(status) {
				const statusMap = {
					0: 'primary',
					1: 'success',
					2: 'danger',
					9: 'info',
					4: 'warning'
				}
				return statusMap[status] || 'info'
			},
			getStatusTextOffer(status) {
				const statusMap = {
					0: '审核中',
					1: '已审核',
					2: '已拒绝',
					9: '待提交',
					4: '已撤回'
				}
				return statusMap[status] || status
			},
			loadData() {
				//if (!val) return
				//const firstDay = dayjs(val).startOf('month').format('YYYY-MM-DD')
				//const lastDayStr = dayjs(val).endOf('month').format('YYYY-MM-DD');
				//this.monthRange = [firstDay, lastDayStr]
				this.fetchStatistics()
				this.fetchTableData()
			},
			handleMonthChange(val) {
				if (!val) return
				const firstDay = dayjs(val).startOf('month').format('YYYY-MM-DD')
				const lastDayStr = dayjs(val).endOf('month').format('YYYY-MM-DD');
				this.monthRange = [firstDay, lastDayStr]
			},
			handleUserChange() {
				if (this.workTab === 'work') {
					this.fetchStatistics()
					this.fetchTableData(this.workTab)
				}
			},
			handleSizeChange(val, type) {
				this[`${type}Pagination`].pageSize = val
				this.fetchTableData(type)
			},
			handleCurrentChange(val, type) {
				this[`${type}Pagination`].current = val
				this.fetchTableData(type)
			},
			getProgressColor(percentage) {
				if (percentage >= 80) return '#67C23A'
				if (percentage >= 60) return '#409EFF'
				if (percentage >= 40) return '#E6A23C'
				return '#F56C6C'
			},
			tableHeaderStyle() {
				return {
					backgroundColor: '#f5f7fa',
					color: '#606266',
					fontWeight: 'bold',
					textAlign: 'center'
				}
			},
			tableCellStyle() {
				return {
					textAlign: 'center'
				}
			},
			async fetchOpportunityList() {
				try {
					const params = {
						sts: dayjs(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
						ets: dayjs(this.selectedMonth).endOf('month').format('YYYY-MM-DD')
					}
					const res = await getOpportunityList(params)
					this.opportunityList = res.data || []
					if (this.activeTab == 'opportunityAnalysis') {
						this.selectedOpportunity = this.opportunityList.length > 0 ? this.opportunityList[0].id : null
					}
				} catch (error) {
					console.error('获取商机列表失败:', error)
					ElMessage.error('获取商机列表失败')
				}
			},
			async handleOpportunityChange(opportunityId) {
				//console.log(this.selectedOpportunity)
				if (!opportunityId) return
				this.loading = true
				try {
					const params = {
						businessId: opportunityId,
						startDate: dayjs('1997-12-12').format('YYYY-MM-DD'),
						endDate: dayjs(new Date()).format('YYYY-MM-DD')
					}
					const res1 = await getStaUser(params)
					this.opportunityPieDataGen = res1.data.pieFollowUpData;
					this.opportunityPieDataHe = res1.data.pieContractData;
					this.opportunityPieDataHui = res1.data.piePaymentData;
					const detail = await getBusinessDetail({
						id: opportunityId
					})
					this.opportunityDetail = detail.data || {};
					const offer = await getBusinessOffer({
						businessId: opportunityId
					})
					this.quotationList = offer.data || []
					const con = await getBusinessContract({
						businessId: opportunityId
					})
					this.contractList = con.data || []
					const rec = await getBusinessRec({
						businessId: opportunityId
					})
					this.paymentList = rec.data || []
					const res = await getOpportunityAnalysis({
						id: opportunityId
					})
					this.opportunityStats = res.data || {}
					const teamRes = await getBusinessTeam({
						businessId: opportunityId
					})
					this.participantAnalysis = teamRes.data || []
					this.fetchFollowUpRecords()
				} catch (error) {
					console.error('获取商机分析数据失败:', error)
					ElMessage.error('获取商机分析数据失败')
				} finally {
					this.loading = false
				}
			},
			async fetchFollowUpRecords() {
				if (!this.selectedOpportunity) return
				this.loading = true
				try {
					const params = {
						userId: this.selectedOpportunity,
						page: this.followUpPagination.current,
						pageSize: this.followUpPagination.pageSize
					}
					const res = await getOpportunityFollowUps(params)
					this.followUpRecords = res.data.records || []
					this.followUpPagination.total = res.data.total || 0
				} catch (error) {
					console.error('获取跟进记录失败:', error)
					ElMessage.error('获取跟进记录失败')
				} finally {
					this.loading = false
				}
			},
			handleResize() {},
			async handlePieChartClick(type, id) {
				this.workDialogType = type
				this.workDialogVisible = true
				this.selectedPieId = id
				// 重置分页
				switch (type) {
					case 'customer':
						this.dialogCustomerPagination.current = 1;
						break;
					case 'opportunity':
						this.dialogOpportunityPagination.current = 1;
						break;
					case 'contract':
						this.dialogContractPagination.current = 1;
						break;
					case 'payment':
						this.dialogPaymentPagination.current = 1;
						break;
				}
				await this.fetchDialogTableData(type, id)
			},
			async fetchDialogTableData(type, id) {
				this.loading = true
				try {
					let page = 1,
						pageSize = 10
					switch (type) {
						case 'customer':
							page = this.dialogCustomerPagination.current
							pageSize = this.dialogCustomerPagination.pageSize
							break
						case 'opportunity':
							page = this.dialogOpportunityPagination.current
							pageSize = this.dialogOpportunityPagination.pageSize
							break
						case 'contract':
							page = this.dialogContractPagination.current
							pageSize = this.dialogContractPagination.pageSize
							break
						case 'payment':
							page = this.dialogPaymentPagination.current
							pageSize = this.dialogPaymentPagination.pageSize
							break
					}
					const params = {
						userId: id,
						startDate: dayjs(this.selectedMonth).startOf('month').format('YYYY-MM-DD'),
						endDate: dayjs(this.selectedMonth).endOf('month').format('YYYY-MM-DD'),
						page,
						pageSize
					}
					let res
					switch (type) {
						case 'customer':
							res = await getCustomerFollowUps(params)
							this.dialogCustomerData = res.data.records || []
							this.dialogCustomerPagination.total = res.data.total || 0
							break
						case 'opportunity':
							res = await getOpportunityConversions(params)
							this.dialogOpportunityData = res.data.records || []
							this.dialogOpportunityPagination.total = res.data.total || 0
							break
						case 'contract':
							res = await getContractSignings(params)
							this.dialogContractData = res.data.records || []
							this.dialogContractPagination.total = res.data.total || 0
							break
						case 'payment':
							res = await getPaymentRecords(params)
							this.dialogPaymentData = res.data.records || []
							this.dialogPaymentPagination.total = res.data.total || 0
							break
					}
				} catch (error) {
					ElMessage.error('获取弹窗表格数据失败')
				} finally {
					this.loading = false
				}
			},
			handleDialogSizeChange(val, type) {
				switch (type) {
					case 'customer':
						this.dialogCustomerPagination.pageSize = val;
						break;
					case 'opportunity':
						this.dialogOpportunityPagination.pageSize = val;
						break;
					case 'contract':
						this.dialogContractPagination.pageSize = val;
						break;
					case 'payment':
						this.dialogPaymentPagination.pageSize = val;
						break;
				}
				this.fetchDialogTableData(type, this.selectedPieId)
			},
			handleDialogCurrentChange(val, type) {
				switch (type) {
					case 'customer':
						this.dialogCustomerPagination.current = val;
						break;
					case 'opportunity':
						this.dialogOpportunityPagination.current = val;
						break;
					case 'contract':
						this.dialogContractPagination.current = val;
						break;
					case 'payment':
						this.dialogPaymentPagination.current = val;
						break;
				}
				this.fetchDialogTableData(type, this.selectedPieId)
			},
			// 处理合同文件预览
			handleContractFilePreview(url) {

				window.open(url)

			},
			// 处理回款单预览
			handleReceiptFilePreview(url) {

				window.open(url)

			},
			async showQuotationDetail(row) {
				const res = await getExamineList({
					offerId: row.id
				})
				this.approvalList = res.data
				this.currentQuotationDetail = row;
				this.quotationDetailDialogVisible = true;
			},
			async handleView(row) {
				const res = await getExamineFlowDetail({
					id: row.id
				});
				this.currentApprovalFlow = res.data || [];
				this.approvalFlowDialogVisible = true;
			},
		},
		watch: {
			activeTab(newVal) {
				if (newVal == 'opportunityAnalysis') {
					this.$nextTick(() => {
						this.selectedOpportunity = this.opportunityList.length > 0 ? this.opportunityList[0].id :
							null
						//this.handleOpportunityChange(this.selectedOpportunity)
					})

				} else {
					this.selectedOpportunity = null
				}
			},
			selectedMonth(newVal) {
				if (this.activeTab === 'opportunityAnalysis') {
					this.fetchOpportunityList()
				} else {
					this.loadData(newVal)
				}
			},
			selectedUser() {
				this.fetchStatistics()
				this.fetchTableData(this.workTab)
			},
			workTab(newVal) {
				this.fetchTableData(newVal)
			},
			customerTypeData: {
				handler() {},
				deep: true
			},
			pieFollowUpData: {
				handler() {},
				deep: true
			},
			pieOpportunityData: {
				handler() {},
				deep: true
			},
			pieContractData: {
				handler() {},
				deep: true
			},
			piePaymentData: {
				handler() {},
				deep: true
			},
			opportunityPieData: {
				handler() {},
				deep: true
			},
			opportunityPieDataGen: {
				handler() {},
				deep: true
			},
			opportunityPieDataHe: {
				handler() {},
				deep: true
			},
			opportunityPieDataHui: {
				handler() {},
				deep: true
			},
			selectedOpportunity(val) {
				if (val) {
					this.handleOpportunityChange(val)
					//this.$nextTick(() => {})
				}
			},
			opportunityAnalysisTab(newVal) {
				if (newVal === 'followUp' && this.selectedOpportunity) {
					this.fetchOpportunityFollowUps()
				} else if (newVal === 'participants' && this.selectedOpportunity) {
					this.fetchParticipantAnalysis()
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.mt-20 {
		margin-top: 10px;
	}

	.pb-10 {
		padding-bottom: 20px;
	}

	.statistics-management {
		padding: 24px;
		background-color: #f0f2f5;
		min-height: 100vh;

		.general-card {
			margin-bottom: 24px;
			border-radius: 8px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
		}

		.page-title {
			padding-right: 24px;
			font-size: 20px;
			font-weight: bold;
			color: #303133;
		}

		.card-header {
			display: flex;
			// justify-content: space-between;
			align-items: center;
			padding: 2px 12px;

			.el-icon {
				margin-left: 8px;
				color: #909399;
				cursor: pointer;
			}
		}

		.header-extra {
			display: flex;
			align-items: center;

			.button-group {
				.el-button {
					border-radius: 4px 0 0 4px;

					&:last-child {
						border-radius: 0 4px 4px 0;
					}
				}

				// &:last-child{
				// 	border-radius: 0 4px 4px 0;
				// }
			}

			.select-group {
				padding-left: 12px;
				padding-right: 12px;
			}
		}

		.section {
			margin-bottom: 40px;
		}

		.section-title {
			font-size: 18px;
			font-weight: bold;
			color: #303133;
			margin-bottom: 20px;
			padding-bottom: 10px;
			border-bottom: 2px solid #409EFF;
		}

		.custom-tabs {
			:deep(.el-tabs__nav-wrap::after) {
				height: 1px;
				background-color: #e4e7ed;
			}

			:deep(.el-tabs__item) {
				font-size: 15px;
				height: 40px;
				line-height: 40px;

				&.is-active {
					font-weight: bold;
				}
			}
		}

		.detail-tabs {
			:deep(.el-tabs__item) {
				font-size: 14px;
			}
		}

		.stat-card {
			transition: all 0.3s;
			border-radius: 8px;
			overflow: hidden;

			&:hover {
				transform: translateY(-5px);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
			}

			.el-card__header {
				padding: 12px 20px;
				border-bottom: 1px solid #ebeef5;
				background-color: #fafafa;
			}
		}

		.statistic-card {
			text-align: center;
			padding: 20px 0;

			.number {
				font-size: 28px;
				font-weight: bold;
				color: #409EFF;
				margin-right: 8px;
			}

			.label {
				color: #909399;
				font-size: 14px;
			}
		}

		.mt-4 {
			margin-top: 16px;
		}

		:deep(.el-table) {
			border-radius: 8px;
			overflow: hidden;

			th {
				background-color: #f5f7fa !important;
			}
		}

		:deep(.el-progress-bar__outer) {
			border-radius: 4px;
		}

		:deep(.el-progress-bar__inner) {
			border-radius: 4px;
		}

		.filter-container {
			display: flex;
			align-items: center;
			margin-bottom: 24px;
			padding: 16px;
			background-color: #fff;
			border-radius: 8px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
		}

		.pagination-container {
			margin-top: 20px;
			display: flex;
			justify-content: flex-end;
		}

		.text-muted {
			color: #909399;
			font-size: 12px;
		}

		:deep(.el-link) {
			font-size: 12px;
		}
	}
</style>
